import type { ParamsValidator } from 'src/components/RouteParamsValidator.tsx';
import type { BroadcastRouteParams } from './types.ts';
import { BroadcastUrlType } from './types.ts';

export const validateBroadcastType: ParamsValidator<BroadcastRouteParams> = ({ broadcastType }) =>
  Object.values(BroadcastUrlType).includes(broadcastType);
